/** Report unique code for the PRM Change Report */
export const PRM_CHANGE_REPORT_UNIQUE_CODE = 'PRM_CHANGE';
